<template>
  <modal-container :id="'fundingModal'" static>
    <form @submit.prevent="submit">
      <div class="modal-header">
        <h5 class="modal-title">{{ payload._id ? 'Edit' : 'Add' }} Existing Funding</h5>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-sm-6">
            <base-field label="Name">
              <base-input v-model="payload.name" placeholder="name" required />
            </base-field>
          </div>
          <div class="col-sm-6">
            <base-field label="Lender">
              <base-input v-model="payload.lender" placeholder="lender" required />
            </base-field>
          </div>
          <div class="col-sm-6">
            <base-field addon-left-icon="pound-sign" label="Amount">
              <base-input v-model="payload.amount" numeric placeholder="amount" required />
            </base-field>
          </div>
          <div class="col-sm-6">
            <base-field addon-left-icon="pound-sign" label="Total Costs">
              <base-input v-model="payload.totalCosts" numeric placeholder="total costs" />
            </base-field>
          </div>
          <div class="col-sm-6">
            <base-field addon-right-icon="percent" label="Interest Rate">
              <base-input v-model="payload.interestRate" numeric placeholder="interest rate" />
            </base-field>
          </div>
          <div class="col-sm-6">
            <base-field addon-right="months" label="Term">
              <base-input v-model="payload.term" numeric placeholder="term" />
            </base-field>
          </div>
          <div class="col-sm-6">
            <base-field label="Charge">
              <base-select v-model="payload.charge" placeholder="charge" source="securityCharges" />
            </base-field>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <base-button data-dismiss="modal">Cancel</base-button>
        <base-button :loading="saving" primary submit>Save</base-button>
      </div>
    </form>
  </modal-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import ModalContainer from './ModalContainer.vue'

export default {
  name: 'FundingModal',

  components: {
    ModalContainer
  },

  created () {
    this.refresh()
  },

  mounted () {
    $('#fundingModal').on('hide.bs.modal', () => {
      this.$emit('closed')
    })
  },

  data () {
    return {
      payload: {},
      saving: false
    }
  },

  props: {
    editing: Object,
    noSave: Boolean
  },

  computed: {
    ...mapGetters({
      schema: 'core/project-funding/schema'
    }),

    ...mapState({
      funding: store => store.core.projectFunding.entity,
      project: store => store.core.projects.entity
    })
  },

  methods: {
    refresh () {
      this.payload = this.$_.cloneDeep(this.schema)
    },

    async submit () {
      const payload = this.$_.cloneDeep(this.payload)
      const created = !this.$_.has(payload, '_id')

      if (this.noSave) {
        this.$emit('submitted', payload)
      } else {
        this.saving = true

        await this.$store.dispatch('core/project-funding/save', payload)

        this.saving = false

        const funding = this.$_.cloneDeep(this.funding)

        this.$emit(created ? 'created' : 'updated', funding)
        this.$emit('saved', funding)
      }

      $('#fundingModal').modal('hide')
    }
  },

  watch: {
    editing () {
      if (this.editing !== null) {
        this.payload = this.$_.cloneDeep(this.editing)
      } else {
        this.refresh()
      }
    }
  }
}
</script>
